module.exports = __webpack_public_path__ + "img/9-2.8f026fa8.png";